export const borderWidthNumber = 0.063
export const borderWidth = `${borderWidthNumber}rem`
export const borderRadius = `${borderWidthNumber * 2}rem`
